import { Grid2 as Grid, LinearProgress, Paper, Typography } from "@mui/material";
import useScreenSize from '../../../../hooks/useScreenSize';
import { formatNumber } from "../../../../hooks/formatNumber";

type ImpressionsProps = {
    impressions: number,
    clicks: number,
    qualityImpressions?: number,
    size?: number
}

const ImpressionsWidget = ({ impressions, clicks, qualityImpressions, size = 4 }: ImpressionsProps) => {
    const clickThroughRate = impressions === 0 ? 0 : Math.round((clicks * 100 / impressions * 100) + Number.EPSILON) / 100;
    const screenSize = useScreenSize();

    const gridSize = qualityImpressions === undefined ? 6 : 4;

    return (
        <Grid size={screenSize.width < 1200 ? 12 : size}>
            <Paper elevation={5} sx={{ 
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 220,
                gap: 2
            }}>
                <Typography variant="h6">Impressions and Click-Through</Typography>
                <Grid container>
                    <Grid size={gridSize}>
                        <Typography>Impressions</Typography>
                        <Typography variant="h4">{formatNumber(impressions)}</Typography>
                    </Grid>
                    <Grid size={gridSize}>
                        <Typography>Clicks</Typography>
                        <Typography variant="h4">{formatNumber(clicks)}</Typography>
                    </Grid>
                    {qualityImpressions !== undefined &&
                        <Grid size={gridSize}>
                            <Typography>Quality Impressions</Typography>
                            <Typography variant="h4">{formatNumber(qualityImpressions)}</Typography>
                        </Grid>
                    }
                </Grid>
                <Grid container gap={1}>
                    <Grid size={12}><Typography>{clickThroughRate}% click-through rate</Typography></Grid>
                    <Grid size={12}>
                        <LinearProgress variant="determinate" value={Math.min(clickThroughRate, 100)} />
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    )
}

export default ImpressionsWidget;
